import { SVGProps } from 'react'

export const TotalAppointmentIcon = ({ fill = 'black', ...rest }: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height="51" viewBox="0 0 51 51" width="51" xmlns="http://www.w3.org/2000/svg">
    <rect fill="#EFE6FF" height="50.0001" rx="25" width="50" x="0.5" y="0.5" />
    <path
      d="M21 16V19"
      stroke="#4900CC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M29 16V19"
      stroke="#4900CC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M16.5 23.0898H33.5"
      stroke="#4900CC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M34 22.5V31C34 34 32.5 36 29 36H21C17.5 36 16 34 16 31V22.5C16 19.5 17.5 17.5 21 17.5H29C32.5 17.5 34 19.5 34 22.5Z"
      stroke="#4900CC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M28.6947 27.6992H28.7037"
      stroke="#4900CC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M28.6947 30.6992H28.7037"
      stroke="#4900CC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M24.9955 27.6992H25.0045"
      stroke="#4900CC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M24.9955 30.6992H25.0045"
      stroke="#4900CC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M21.2943 27.6992H21.3033"
      stroke="#4900CC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M21.2943 30.6992H21.3033"
      stroke="#4900CC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
)

export const UpcomingAppointmentIcon = ({ fill = 'black', ...rest }: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height="51" viewBox="0 0 51 51" width="51" xmlns="http://www.w3.org/2000/svg">
    <rect fill="#E9EFFB" height="50.0001" rx="25" width="50" x="0.5" y="0.5" />
    <path
      d="M22 16V19"
      stroke="#245EDB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M30 16V19"
      stroke="#245EDB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M17.5 23.0898H34.5"
      stroke="#245EDB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M35 22.5V31C35 34 33.5 36 30 36H22C18.5 36 17 34 17 31V22.5C17 19.5 18.5 17.5 22 17.5H30C33.5 17.5 35 19.5 35 22.5Z"
      stroke="#245EDB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M29.6947 27.6992H29.7037"
      stroke="#245EDB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M29.6947 30.6992H29.7037"
      stroke="#245EDB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M25.9955 27.6992H26.0045"
      stroke="#245EDB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M25.9955 30.6992H26.0045"
      stroke="#245EDB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M22.2943 27.6992H22.3033"
      stroke="#245EDB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M22.2943 30.6992H22.3033"
      stroke="#245EDB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
)

export const CompletedAppointmentIcon = ({ fill = 'black', ...rest }: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height="51" viewBox="0 0 51 51" width="51" xmlns="http://www.w3.org/2000/svg">
    <rect fill="#E6FFE8" height="50.0001" rx="25" width="50" x="0.5" y="0.5" />
    <path
      d="M21 15V18"
      stroke="#27AE60"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M29 15V18"
      stroke="#27AE60"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M16.5 22.0898H33.5"
      stroke="#27AE60"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M34 21.5V30C34 33 32.5 35 29 35H21C17.5 35 16 33 16 30V21.5C16 18.5 17.5 16.5 21 16.5H29C32.5 16.5 34 18.5 34 21.5Z"
      stroke="#27AE60"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M28.6947 26.6992H28.7037"
      stroke="#27AE60"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M28.6947 29.6992H28.7037"
      stroke="#27AE60"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M24.9955 26.6992H25.0045"
      stroke="#27AE60"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M24.9955 29.6992H25.0045"
      stroke="#27AE60"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M21.2943 26.6992H21.3033"
      stroke="#27AE60"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M21.2943 29.6992H21.3033"
      stroke="#27AE60"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
)

export const CancelledAppointmentIcon = ({ fill = 'black', ...rest }: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height="51" viewBox="0 0 51 51" width="51" xmlns="http://www.w3.org/2000/svg">
    <rect fill="#F3F3F1" height="50.0001" rx="25" width="50" x="0.5" y="0.5" />
    <path
      d="M22 16V19"
      stroke="#D95069"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M30 16V19"
      stroke="#D95069"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M17.5 23.0898H34.5"
      stroke="#D95069"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M35 22.5V31C35 34 33.5 36 30 36H22C18.5 36 17 34 17 31V22.5C17 19.5 18.5 17.5 22 17.5H30C33.5 17.5 35 19.5 35 22.5Z"
      stroke="#D95069"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M29.6947 27.6992H29.7037"
      stroke="#D95069"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M29.6947 30.6992H29.7037"
      stroke="#D95069"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M25.9955 27.6992H26.0045"
      stroke="#D95069"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M25.9955 30.6992H26.0045"
      stroke="#D95069"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M22.2943 27.6992H22.3033"
      stroke="#D95069"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M22.2943 30.6992H22.3033"
      stroke="#D95069"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
)
